import { Component, h, Prop, State, Element, Watch } from '@stencil/core';

@Component({
  tag: 'vsr-video',
  styleUrl: 'vsr-video.scss',
  shadow: true,
})
export class VsrVideo {
  @Element() host: HTMLElement;
  private videoEl!: HTMLVideoElement;
  private io!: IntersectionObserver;

  @Prop() src!: string;
  @Prop() poster = '';
  @Prop() alt = 'Video';
  @Prop() videoType: 'video-loop' | 'video-single' = 'video-single';
  @Prop({ mutable: true }) autoplay: true | false = true;
  @Prop({ mutable: true }) muted: true | false = true;
  @Prop() preload: 'none' | 'metadata' | 'auto' = 'metadata';

  @State() inView = false;
  @State() loaded = false;
  @State() error = false;
  @State() playing = false;

  @Watch('src')
  validateSrc(newVal: string) {
    if (!newVal || newVal.trim() === '') {
      console.error('<vsr-video> "src" property is mandatory.');
    }
    this.src = newVal;
  }

  componentWillLoad() {
    this.validateSrc(this.src);
    // const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // if (prefersReducedMotion) {
    //   this.autoplay = false;
    // }
  }

  disconnectedCallback() {
    this.io && this.io.disconnect();
  }

  private handleLoaded = () => {
    this.loaded = true;
    if ((this.videoType === 'video-loop' || this.videoType === 'video-single') && this.autoplay) {
      this.videoEl
        .play()
        .then(() => (this.playing = true))
        .catch(() => {});
    }
  };

  private handleEnded = () => {
    if (this.videoType === 'video-single') {
      this.playing = false;
      this.videoEl.currentTime = 0;
    }
  };

  private handleError = (e: Event) => {
    console.error('vsr-video: failed to load', e);
    this.error = true;
  };

  // private handleClick = () => {
  //   if (this.videoEl.paused) {
  //     this.videoEl
  //       .play()
  //       .then(() => (this.playing = true))
  //       .catch(() => {});
  //   } else {
  //     this.videoEl.currentTime = 0;
  //     this.videoEl.pause();
  //     this.playing = false;
  //   }
  // };

  render() {
    const showPoster = !this.playing;
    return (
      <div
        class={{
          'vsr-video-wrapper': true,
          'show-poster': showPoster,
          error: this.error,
        }}
        style={showPoster && this.poster ? { '--vsr-video-poster': `url('${this.poster}')` } : {}}
        // onClick={this.handleClick}
      >
        <video
          ref={el => (this.videoEl = el)}
          class="vsr-video"
          poster={this.poster}
          muted={this.muted}
          autoplay={this.autoplay}
          playsInline
          loop={this.videoType === 'video-loop'}
          preload={this.preload}
          onLoadedData={this.handleLoaded}
          onEnded={this.handleEnded}
          onError={this.handleError}
          aria-label={this.alt}
          controls={true}
        >
          <source src={this.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }
}
